import { Team } from "../../../../src/components/team";
import * as React from 'react';
export default {
  Team,
  React
};